import styled from 'styled-components';

import { FormControl } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';

export const FormStyled = styled.form`
  position: relative;
  padding: 1rem;
`;

export const styleModal = {
  overflow: 'visible',
}

export const DoneIconStyled = styled(DoneIcon)`
  color: ${props => props.color ? props.color : 'green'} !important;
`;
export const FormControlRadioStyled = styled(FormControl)`
  margin-left: 40px !important;
`;
export const DivSubmitButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: '20px 0';
`
export const DivSpinner = styled.div`
display: flex;
justify-content: center;
margin-top: 20px;
`;

export const DivFormTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Preview = styled.img`
  width: 121.95px;
  height: 250px;
  border-radius: 5px;
  object-fit: contain;
  transform: rotate(-90deg);
  backgroundColor: red;
  margin: -60px 0 -70px 65px;
  border-radius: 5px;
  background-color: white;
`;
